import { Link, useNavigate } from "react-router-dom";
import "./post.css";

export default function Post({ post }) {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    // Prevent navigation if a real link was clicked
    if (e.target.closest("a")) return;
    navigate(`/post/${post?.documentId}`);
  };

  return (
    <div
      className="post shadow-elevation-darkbg-medium"
      onClick={handleCardClick}
    >
      {post.photo && (
        <div className="postImgWrapper">
          <img
            className="postImg"
            src={`${process.env.REACT_APP_UPLOAD_URL}${
              post.photo?.formats?.small?.url || post.photo?.url
            }`}
            alt=""
          />
          <div className="postImgStats">
            <span
              className={`statLight ${post.likes ? "" : "d-none"}`}
              title="Total Likes"
            >
              <i className="fa-regular fa-heart"></i>
              {post.likes}
            </span>
          </div>
        </div>
      )}

      <div className="postInfo">
        <div className="d-flex flex-row justify-content-between w-100">
          <div className="postCatWrapper">
            {post.categories?.map((c, index) => (
              <span key={`postCat${index}`} className="postCat">
                <Link className="link" to={`/posts?cat=${c.documentId}`}>
                  {c.name}
                </Link>
              </span>
            ))}
          </div>
          <Link to={`/posts?createdAt=${post.createdAt}`} className="link">
            <span className="postDate">
              {new Date(post.createdAt).toDateString()}
            </span>
          </Link>
        </div>

        <span className="postTitle">{post.title}</span>
        <p className="postDesc">{post.description?.split(".")[0]}</p>
        <div className="d-flex w-100 justify-content-end align-items-center gap-1 readmore-wrapper">
          <span className="readmore">Read more</span>
          <i className="fa-solid fa-circle-right readmore"></i>
        </div>
      </div>
    </div>
  );
}
